import { SignalTypeMeta } from "@megaron/resource";

import { CustomerDoc } from "./customerDoc";
import { OrderDoc } from "./orderDoc";

type CrmDocType = (CustomerDoc | OrderDoc)["docType"];

export const crmSignalTypes = {
  regionCustomer: {
    subjectDocType: "customer",
    level: "info",
    app: "crm",
    actionLabel: "Nowy klient w regionie",
  },
  regionCustomerMissingPhone: {
    subjectDocType: "customer",
    level: "warning",
    app: "crm",
    actionLabel: "Brak numeru telefonu",
  },
  regionCustomerMissingEmail: {
    subjectDocType: "customer",
    level: "warning",
    app: "crm",
    actionLabel: "Brak adresu e-mail",
  },
  posCustomerMissingGooglePlaceId: {
    subjectDocType: "customer",
    level: "warning",
    app: "crm",
    actionLabel: "Brak Google Place ID (POS)",
  },
  crmInteractionMention: {
    subjectDocType: "customer",
    level: "info",
    app: "crm",
    actionLabel: "Oznaczenie w interakcji w CRM",
  },
  crmOrderSuspended: {
    subjectDocType: "customer",
    level: "warning",
    app: "crm",
    actionLabel: "Zamówienie wstrzymane",
  },
} as const satisfies Record<string, SignalTypeMeta<CrmDocType>>;
